import { Box } from '@nimbus-ds/components';
import { CancelAndConfirmButtons } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { ExactProductSetToggle } from './ExactProductSetToggle';
import { ProductSearcherFooterProps } from '../../ProductSearcher';

interface ProductSearcherConfirmProps {
  footerProps: ProductSearcherFooterProps<true>;
  exactProductSet: boolean;
  onExactProductSetChange: () => void;
}

export function ProductSearcherConfirmOrderFilters({
  footerProps,
  exactProductSet = false,
  onExactProductSetChange,
}: Readonly<ProductSearcherConfirmProps>) {
  const t = useTranslationOrders();

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="100%"
      gap="2"
    >
      <ExactProductSetToggle
        active={exactProductSet}
        onChange={onExactProductSetChange}
      />

      <Box display="flex" alignItems="center">
        <CancelAndConfirmButtons
          isConfirmDisabled={!footerProps.selectedProducts.length}
          onCancel={footerProps.onClose}
          onConfirm={footerProps.onSubmit}
          confirmText={t('productSearcher.searcherConfirm.saveConfirm')}
        />
      </Box>
    </Box>
  );
}
